import { render } from "./SupportOld2024Detail.vue?vue&type=template&id=adf6b8d6&scoped=true"
import script from "./SupportOld2024Detail.vue?vue&type=script&lang=js"
export * from "./SupportOld2024Detail.vue?vue&type=script&lang=js"

import "./SupportOld2024Detail.vue?vue&type=style&index=0&id=adf6b8d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf6b8d6"]])

export default __exports__